import { useState } from 'react'
import { ReactComponent as InfoSVG } from '../../assets/info.svg'

import './GuidanceIcon.scss'
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/Tooltip'

/**
 * A small util hook to enable only one compliance tooltip showing at a time.
 */
export const useGuidanceManager = () => {
  const [count, setCount] = useState(1)

  const take = () => {
    setCount((count) => count + 1)
  }

  return {
    count,
    take
  }
}

/**
 * GuidanceIcon component for question-level guidance.
 *
 * @param {Object} props
 * @param {Array<{ text: string, link?: string }>} props.guidance
 * @param {{ count: number, take: () => void }} props.manager
 *
 * @returns {JSX.Element|string}
 */
export const GuidanceIcon = (props) => {
  const [ourCount, setOurCount] = useState(0)
  const isOpen = props.manager?.count === ourCount

  if (!props.guidance?.length) return ''

  return (
    <span className='guidance-icon'>
      <Tooltip>
        <TooltipTrigger>
          <span
            className='info-button'
            onClick={() => {
              if (isOpen) {
                setOurCount(0)
              } else {
                setOurCount(props.manager.count + 1)
                props.manager.take()
              }
            }}
          >
            <InfoSVG />
          </span>
        </TooltipTrigger>
        <TooltipContent
          style={{
            // Absolute hack because of alignment issues against
            // the ComplianceIcon. These icons need better positioning with
            // flex etc. and so the accordion isn't coupled to this icon's
            // position. Deferring until a UI library is in place...s
            top: 'calc(50% - 3px)'
          }}
        >
          {isOpen ? 'Close' : 'Open'} Response Guidance
        </TooltipContent>
      </Tooltip>

      <ul className='guidance' style={isOpen ? { maxHeight: '1000px', marginTop: '10px' } : { maxHeight: 0, marginTop: 0 }}>
        {props.guidance.map((line) => {
          const textContent = line.text.split('\n').map((t, i) => (
            <>
              {t}
              <br />
            </>
          ))

          return line.link ? (
            <li key={line.text}>
              <a href={line.link} target='_blank' rel='noreferrer'>
                {textContent}
              </a>
            </li>
          ) : (
            <li className='disc' key={line.text}>
              {textContent}
            </li>
          )
        })}
      </ul>
    </span>
  )
}
